module.exports = __webpack_public_path__ + "static/img/order_icon.835efdf5.svg";